import { type FunctionComponent } from 'react';
import { ACCOUNT_PROJECTS_DETAILS, ACCOUNT_PROJECTS_LINK } from '../../../constants/links';
import { type ProjectSuccessActions } from '../../../constants/project/general';
import { generatePath } from '../../../utils/routing/route.utils';
import { StyledLink } from '../../common-components/link/styled-link.component';

type ProjectFragment = { id: number; name: string; isLocked?: boolean };
const actionMessageMap = {
	COPY: {
		message: 'Copied to',
		appliedAction: 'Copied'
	},
	MOVE: {
		message: 'Moved to',
		appliedAction: 'Moved'
	},
	SAVE: {
		message: 'We updated',
		appliedAction: 'Saved'
	},
	ATTACH: {
		message: 'We updated',
		appliedAction: 'Attached'
	}
};

export type SavetoProjectSuccessBannerProps = {
	action: ProjectSuccessActions;
	project?: ProjectFragment;
};

export const SaveToProjectSuccessBanner: FunctionComponent<SavetoProjectSuccessBannerProps> = ({ action, project }) => {
	const link = project ? generatePath(ACCOUNT_PROJECTS_DETAILS, { projectId: project.id }) : ACCOUNT_PROJECTS_LINK;

	return (
		<>
			{project ? (
				<>
					{actionMessageMap[action].appliedAction} to{' '}
					<StyledLink className="font-medium!" color="success" underline={true} url={link}>
						{project.name}
					</StyledLink>
					.
				</>
			) : (
				<>
					{actionMessageMap[action].message}{' '}
					<StyledLink className="font-medium!" color="success" underline={true} url={link}>
						your projects
					</StyledLink>
					!
				</>
			)}
		</>
	);
};
